import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import StudioRuntimeShell from "../../features/firestoreStudio/runtime/StudioRuntimeShell";
import { FirestoreAdminProvider } from "../../features/firestoreAdmin/context/FirestoreAdminProvider";
import FirestoreAdminLayout from "../../features/firestoreAdmin/components/FirestoreAdminLayout";
import DashboardPage from "../../features/firestoreAdmin/pages/DashboardPage";
import ExplorerPage from "../../features/firestoreAdmin/pages/ExplorerPage";
import RestoreCenterPage from "../../features/firestoreAdmin/pages/RestoreCenterPage";
import QueryBuilderPage from "../../features/firestoreAdmin/pages/QueryBuilderPage";
import DeleteByConditionPage from "../../features/firestoreAdmin/pages/DeleteByConditionPage";
import UpdateByConditionPage from "../../features/firestoreAdmin/pages/UpdateByConditionPage";
import FindReplacePage from "../../features/firestoreAdmin/pages/FindReplacePage";
import SchedulerPage from "../../features/firestoreAdmin/pages/SchedulerPage";
import UndoCenterPage from "../../features/firestoreAdmin/pages/UndoCenterPage";
import DuplicateFinderPage from "../../features/firestoreAdmin/pages/DuplicateFinderPage";
import RelationshipViewerPage from "../../features/firestoreAdmin/pages/RelationshipViewerPage";
import AnalyzerPage from "../../features/firestoreAdmin/pages/AnalyzerPage";
import SchemaGuardPage from "../../features/firestoreAdmin/pages/SchemaGuardPage";
import IndexAdvisorPage from "../../features/firestoreAdmin/pages/IndexAdvisorPage";
import SavedViewsPage from "../../features/firestoreAdmin/pages/SavedViewsPage";
import FieldManagerPage from "../../features/firestoreAdmin/pages/FieldManagerPage";
import ImportExportPage from "../../features/firestoreAdmin/pages/ImportExportPage";
import AuditLogPage from "../../features/firestoreAdmin/pages/AuditLogPage";
import MonitorPage from "../../features/firestoreAdmin/pages/MonitorPage";
import GlobalSearchPage from "../../features/firestoreAdmin/pages/GlobalSearchPage";
import PermissionsPage from "../../features/firestoreAdmin/pages/PermissionsPage";

export default function FirestoreDataManagerPage() {
  return (
    <StudioRuntimeShell>
      <FirestoreAdminProvider>
      <Routes>
        <Route element={<FirestoreAdminLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="explorer" element={<ExplorerPage />} />
          <Route path="update-condition" element={<UpdateByConditionPage />} />
          <Route path="delete-condition" element={<DeleteByConditionPage />} />
          <Route path="find-replace" element={<FindReplacePage />} />
          <Route path="undo" element={<UndoCenterPage />} />
          <Route path="scheduler" element={<SchedulerPage />} />
          <Route path="duplicates" element={<DuplicateFinderPage />} />
          <Route path="relationships" element={<RelationshipViewerPage />} />
          <Route path="restore" element={<RestoreCenterPage />} />
          <Route path="query" element={<QueryBuilderPage />} />
          <Route path="analyzer" element={<AnalyzerPage />} />
          <Route path="schema-guard" element={<SchemaGuardPage />} />
          <Route path="index-advisor" element={<IndexAdvisorPage />} />
          <Route path="saved-views" element={<SavedViewsPage />} />
          <Route path="fields" element={<FieldManagerPage />} />
          <Route path="import-export" element={<ImportExportPage />} />
          <Route path="audit" element={<AuditLogPage />} />
          <Route path="monitor" element={<MonitorPage />} />
          <Route path="search" element={<GlobalSearchPage />} />
          <Route path="permissions" element={<PermissionsPage />} />
          <Route path="*" element={<Navigate to="." replace />} />
        </Route>
      </Routes>
      </FirestoreAdminProvider>
    </StudioRuntimeShell>
  );
}
